const createRestoreTimeApi = ({ restoreTime }) => ({
    restoreTime: {
        formatData: restoreTime.formatData,
    },
});
const restoreTimeApiDefinition = {
    id: 'restoreTimeApi',
    type: 'api',
    factory: createRestoreTimeApi,
    dependencies: ['restoreTime'],
};
export default restoreTimeApiDefinition;
